import { render, staticRenderFns } from "./LegacyOrgsView.vue?vue&type=template&id=3294b4cc&"
import script from "./LegacyOrgsView.vue?vue&type=script&lang=js&"
export * from "./LegacyOrgsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports